import _defineProperty from "/var/www/html/formazione-corsiecm.it/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/html/formazione-corsiecm.it/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "bsPrefix", "className", "children", "eventKey"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import * as React from 'react';
import { useContext } from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import Collapse from './Collapse';
import AccordionContext, { isAccordionItemSelected } from './AccordionContext';
import { jsx as _jsx } from "react/jsx-runtime";
var AccordionCollapse = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      eventKey = _ref.eventKey,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(AccordionContext),
      activeEventKey = _useContext.activeEventKey;

  bsPrefix = useBootstrapPrefix(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/_jsx(Collapse, _objectSpread(_objectSpread({
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey)
  }, props), {}, {
    className: classNames(className, bsPrefix),
    children: /*#__PURE__*/_jsx(Component, {
      children: React.Children.only(children)
    })
  }));
});
AccordionCollapse.displayName = 'AccordionCollapse';
export default AccordionCollapse;